import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Mutex } from 'async-mutex';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FileStorageInjectionToken, FileStorageServiceInterface } from '../../interfaces/file-storage.interface';
import {
    JsonWorkWeekdayModel,
    WorkWeekdayModel,
    WorkWeekdayModelFromJson,
} from '../../models/complex/work-weekday.model';
import { isFileError } from '../../utilities/is-file-error';
import { LocalStorageCommonService } from '../local-storage/local-storage-common.service';

const WEEKLY_WORK_MODEL_KEY = 'WorkWeekdayModel';

@Injectable({
    providedIn: 'root',
})
export class WeeklyWorkTimeFileStorageService {
    private readonly weeklyWorkMutex: Mutex;
    public constructor(
        private readonly localStorageCommonService: LocalStorageCommonService,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        @Inject(FileStorageInjectionToken) private readonly fileStorage: FileStorageServiceInterface,
    ) {
        this.weeklyWorkMutex = new Mutex();
    }

    public getWeeklyWorkModel(): Observable<WorkWeekdayModel> {
        return this.fileStorage
            .loadCompressedData<JsonWorkWeekdayModel>(this.weeklyWorkMutex, WEEKLY_WORK_MODEL_KEY)
            .pipe(
                map((jsonWeeklyWorkModel) => new WorkWeekdayModelFromJson(jsonWeeklyWorkModel)),
                catchError((error) => {
                    if (isFileError(error) && error.code === 1) {
                        this.log.debug(`WeeklyWorkTimeFileStorageService: getWeeklyWorkModel: Work time was not found`);
                    }
                    return of(new WorkWeekdayModel([]));
                }),
            );
    }

    public saveWeeklyWorkModel(weeklyWorkList: WorkWeekdayModel): Observable<WorkWeekdayModel> {
        return this.fileStorage.storeCompressedData(this.weeklyWorkMutex, WEEKLY_WORK_MODEL_KEY, weeklyWorkList);
    }
}
